// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_auth_auth_module_ts":"5b3909fb207e58a7","src_app_admin_admin_module_ts":"a5d6c8e5784e5471","node_modules_quill_quill_js":"9bb68a1a38615386"}[chunkId] + ".js";
};